export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'success',
          text: 'Nuevo'
        }
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Mis Tareas',
        to: '/tareas/mistareas',
        icon: 'cil-puzzle'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Mis Calificaciones',
        to: '/calificaciones/miscalificaciones',
        icon: 'cil-calculator'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Horario de Clases',
        to: '/horarios/horarioclases',
        icon: 'cil-calendar'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Matricula 2021',
        to: '/matriculas/matricula2021',
        icon: 'cil-calendar'
      }
    ]
  }
]